import type { Graph, Thing, WithContext } from 'schema-dts'
import { useServerHead, useState } from '#imports'

/**
 * Composable for working with application/ld+json data
 */
export const useSeoSchema = () => {
    const state = useState<Array<Thing>>('seo:structuredData', () => [])

    if (import.meta.client) {
        return {
            state,
            add() {},
        }
    }

    function add(value: Thing) {
        state.value.push(value)
    }

    useServerHead(() => {
        const [first] = state.value
        let schema: WithContext<Thing> | Graph

        if (state.value.length === 1 && typeof first === 'object') {
            schema = {
                '@context': 'https://schema.org',
                ...first,
            } as WithContext<Thing>
        }
        else {
            schema = {
                '@context': 'https://schema.org',
                '@graph': state.value,
            } satisfies Graph
        }

        return {
            script: [
                {
                    type: 'application/ld+json',
                    id: 'structured-data',
                    innerHTML: JSON.stringify(schema),
                },
            ],
        }
    })

    return {
        state,
        add,
    }
}
